export default require('../table/Textarea').default.concat();


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/form/Textarea.js
// module id = 278
// module chunks = 0